import { render } from "./Community.vue?vue&type=template&id=2a161872&scoped=true"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"

import "./Community.vue?vue&type=style&index=0&id=2a161872&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1848005579/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a161872"]])

export default __exports__